import { render, staticRenderFns } from "./RoundedWebsiteIcon.vue?vue&type=template&id=9b7d80a4"
import script from "./RoundedWebsiteIcon.vue?vue&type=script&lang=js"
export * from "./RoundedWebsiteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports